import createIcon from '../../createIcon';

/**
 * @component @name FolderShared
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxMkwxMCA0SDRDMi45IDQgMi4wMSA0LjkgMi4wMSA2TDIgMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY4QzIyIDYuOSAyMS4xIDYgMjAgNlpNMTUgOUMxNi4xIDkgMTcgOS45IDE3IDExQzE3IDEyLjEgMTYuMSAxMyAxNSAxM0MxMy45IDEzIDEzIDEyLjEgMTMgMTFDMTMgOS45IDEzLjkgOSAxNSA5Wk0xOSAxN0gxMVYxNkMxMSAxNC42NyAxMy42NyAxNCAxNSAxNEMxNi4zMyAxNCAxOSAxNC42NyAxOSAxNlYxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderShared = createIcon('FolderShared', [
  [
    'path',
    {
      d: 'M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM15 9C16.1 9 17 9.9 17 11C17 12.1 16.1 13 15 13C13.9 13 13 12.1 13 11C13 9.9 13.9 9 15 9ZM19 17H11V16C11 14.67 13.67 14 15 14C16.33 14 19 14.67 19 16V17Z',
      key: 'xyoxzm',
    },
  ],
]);

export default FolderShared;
